export default "__VITE_ASSET__f5167036__"